import { Injectable } from '@angular/core';
import { FascicoloFull } from "../../../common/models/fascicolo/fascicolo-full";
import { RowSezione } from "../../../common/models/fascicolo/row-sezione";
import { VoceSezione } from "../../../common/models/fascicolo/voce-sezione";
import { FormCautelareComponent } from "../form-cautelare/form-cautelare.component";
import { FormCautelareViewComponent } from "../form-cautelare/view/form-cautelare-view.component";
import { FormDibattimentoComponent } from "../form-dibattimento/form-dibattimento.component";
import { FormDibattimentoViewComponent } from "../form-dibattimento/view/form-dibattimento-view.component";
import { FormIndaginiPreliminariComponent } from "../form-indagini-preliminari/form-indagini-preliminari.component";
import {
  FormIndaginiPreliminariViewComponent
} from "../form-indagini-preliminari/view/form-indagini-preliminari-view.component";
import { FormRitiAlternativiComponent } from "../form-riti-alternativi/form-riti-alternativi.component";
import { FormRitiAlternativiViewComponent } from "../form-riti-alternativi/view/form-riti-alternativi-view.component";
import { FascicoloCautelare } from "../models/cautelare/fascicolo-cautelare";
import { FascicoloDibattimento } from "../models/dibattimento/fascicolo-dibattimento";
import { FascicoloIndaginiPreliminari } from "../models/indagini-preliminari/fascicolo-indagini-preliminari";
import { FascicoloRitiAlternativi } from "../models/riti-alternativi/fascicolo-riti-alternativi";
import { FascicoloOrdinario } from '../models/ordinario/fascicolo-ordinario';
import { FormOrdinarioViewComponent } from '../form-ordinario/view/form-ordinario-view.component';
import { FormOrdinarioComponent } from "../form-ordinario/form-ordinario.component";
import { FascicoloGenerico } from '../models/generico/fascicolo-generico';
import { FormGenericoViewComponent } from '../form-generico/view/form-generico-view.component';
import { FormGenericoComponent } from '../form-generico/form-generico.component';
import { FascicoloUdienzaPreliminare } from '../models/udienza-preliminare/fascicolo-udienza-preliminare';
import { FormUdienzaPreliminareViewComponent } from '../form-udienza-preliminare/view/form-udienza-preliminare-view.component';
import { FormUdienzaPreliminareComponent } from '../form-udienza-preliminare/form-udienza-preliminare.component';
import { FascicoloPredibattimento } from '../models/predibattimento/fascicolo-predibattimento';
import { FormPredibattimentoViewComponent } from '../form-predibattimento/view/form-predibattimento-view.component';
import { FormPredibattimentoComponent } from '../form-predibattimento/form-predibattimento.component';

@Injectable({
  providedIn: 'root'
})

export class FascicoloService {

  constructor() { }

  getFascicolo(genericFascicolo): any {
    let fascicolo;
    switch (genericFascicolo) {
      case 'cautelare': {
        fascicolo = new FascicoloCautelare();
        break;
      }
      case 'dibattimento': {
        fascicolo = new FascicoloDibattimento();
        break;
      }
      case 'ritoalternativo': {
        fascicolo = new FascicoloRitiAlternativi();
        break;
      }
      case 'indaginipreliminari': {
        fascicolo = new FascicoloIndaginiPreliminari();
        break;
      }
      case 'ordinario': {
        fascicolo = new FascicoloOrdinario();
        break;
      }
      case 'genericogiudiziale': {
        fascicolo = new FascicoloGenerico();
        break;
      }
      case 'udienzapreliminare': {
        fascicolo = new FascicoloUdienzaPreliminare();
        break;
      }
      case 'predibattimento': {
        fascicolo = new FascicoloPredibattimento();
        break;
      }
    }
    return fascicolo;
  }

  getComponentFromFormTenant(idFormTenant, view = false) {
    let component;

    switch (idFormTenant) {
      case 'PenCau_PRD': {
        component = view ? FormCautelareViewComponent : FormCautelareComponent; // "CAUTELARE"
        break;
      }
      case 'PenDib_PRD': {
        component = view ? FormDibattimentoViewComponent : FormDibattimentoComponent; // "DIBATTIMENTO"
        break;
      }
      case 'PenRal_PRD': {
        component = view ? FormRitiAlternativiViewComponent : FormRitiAlternativiComponent; // "RITI ALTERNATIVI "
        break;
      }
      case 'PenInd_PRD': {
        component = view ? FormIndaginiPreliminariViewComponent : FormIndaginiPreliminariComponent; // "INDAGINI PRELIMINARI"
        break;
      }
      case 'PenOrd_PRD': {
        component = view ? FormOrdinarioViewComponent : FormOrdinarioComponent; // "ORDINARIO"
        break;
      }
      case 'PenGen_PRD': {
        component = view ? FormGenericoViewComponent : FormGenericoComponent; // "GENERICO";
        break;
      }
      case 'PenUdiPre_PRD': {
        component = view ? FormUdienzaPreliminareViewComponent : FormUdienzaPreliminareComponent; // "UDIENZA PRELIMINARE";
        break;
      }
      case 'PenPreDib_PRD': {
        component = view ? FormPredibattimentoViewComponent : FormPredibattimentoComponent; // "PREDIBATTIMENTO"
        break;
      }
    }
    return component;
  }

  getMappaCopertinaFascicolo(genericFascicolo: string, fascicolo: FascicoloFull, viewComponentDynamic: string, assegnatario?: string): RowSezione[] {
    let esiti = this.getEsitiFromCopertina(fascicolo);
    console.log(fascicolo);
    let udienzeEsiti = this.getUdienzeEsitiFromCopertina(fascicolo);
    // todo: ottimizzare funzione + gestire viewComponentDynamic;
    switch (genericFascicolo) {
      case 'cautelare': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'dibattimento': 
      case 'udienzapreliminare': 
      case 'predibattimento': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ritoalternativo': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
        new RowSezione(null, [
          new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
        ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.praticaBase.intestazione.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione('Giudici', [
            new VoceSezione(4, 'text', 'Giudice indagini preliminari (GIP)', fascicolo.copertina.campi.giudiceIndaginiPreliminari),
            new VoceSezione(4, 'text', 'Giudice udienza preliminare (GUP)', fascicolo.copertina.campi.giudiceUdienzaPreliminare),
            new VoceSezione(4, 'text', 'Pubblico ministero (PM)', fascicolo.copertina.campi.pubblicoMinistero)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'indaginipreliminari': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : ''))
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione('Giudici', [
            new VoceSezione(4, 'text', 'Giudice indagini preliminari (GIP)', fascicolo.copertina.campi.giudiceIndaginiPreliminari),
            new VoceSezione(4, 'text', 'Giudice udienza preliminare (GUP)', fascicolo.copertina.campi.giudiceUdienzaPreliminare),
            new VoceSezione(4, 'text', 'Pubblico ministero (PM)', fascicolo.copertina.campi.pubblicoMinistero)
          ]),
          new RowSezione('Richieste', [
            new VoceSezione(3, 'boolean', 'Richiesta archiviazione al GIP', fascicolo.copertina.campi.richiestaArchiviazione),
            new VoceSezione(3, 'boolean', 'Rimaldo al PM per ulteriori indagini', fascicolo.copertina.campi.rimandoAlPubblicoMinistero),
            new VoceSezione(3, 'boolean', 'Incidente probatorio', fascicolo.copertina.campi.incidenteProbatorio),
            new VoceSezione(3, 'boolean', 'Richiesta rinvio a giudizio', fascicolo.copertina.campi.richiestaRinvioAGiudizio)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ordinario':
      case 'genericogiudiziale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
    }
  }

  getEsitiFromCopertina(fascicolo: FascicoloFull): any[]{
    let listaVoci = [];
    if (fascicolo.copertina.campi.esiti) {
      for (let esito of fascicolo.copertina.campi.esiti) {
        listaVoci.push(new VoceSezione(3, "text", "Esito", esito.esitoPerSocieta));
        listaVoci.push(new VoceSezione(3, "text", "Tipo", esito.tipoSentenza));
        listaVoci.push(new VoceSezione(3, "text", "Numero/Anno", esito.numeroSentenza));
        listaVoci.push(new VoceSezione(3, "text", "Risoluzione per parte", esito.esitoRisoluzioneParte));
      }
    }
    return listaVoci;
  }

  getUdienzeEsitiFromCopertina(fascicolo: FascicoloFull): any[] {
    let listaVoci = [];
    if (fascicolo.copertina.campi.scadenze) {
      for (let i = 0; i < fascicolo.copertina.campi.scadenze.length; i++) {
        let esitoUdienza = fascicolo.copertina.campi.scadenze[i];
    
        listaVoci.push(new VoceSezione(4, "text", "Adempimento", esitoUdienza.tipoAdempimento ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data udienza", esitoUdienza.dataUdienza ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Tipo provvedimento", esitoUdienza.tipoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Numero/Anno esito", esitoUdienza.numeroAnnoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data pubblicazione", esitoUdienza.dataPubblicazione ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Esito", esitoUdienza.esito ?? ""));
        listaVoci.push(new VoceSezione(12, "text", "Note udienza", esitoUdienza.noteUdienza ?? ""));    
        // Aggiungi il divider solo se ci sono almeno due elementi e NON per l'ultima iterazione
        if (fascicolo.copertina.campi.scadenze.length > 1 && i < fascicolo.copertina.campi.scadenze.length - 1) {
          listaVoci.push(new VoceSezione(12, "divider", "", ""));
        }
      }
    }
     
    return listaVoci;
  }
}
